// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3aNwC","clinicsSelect":"styles_clinicsSelect__1Qquz"};